// src/hooks/useCollapsedSection.ts
// Phase-4 Runde 2a (Seitenleiste, "Werkzeuge" einklappbar): gleiches Lazy-localStorage-
// Muster wie useViewMode.ts, hier zusaetzlich mit try/catch auch um den LESE-Zugriff (nicht
// nur ums Schreiben) -- localStorage.getItem() kann im privaten Modus/bei blockiertem
// Site-Data ebenfalls werfen, nicht nur setItem().
import * as React from "react";

export function useCollapsedSection(key: string, defaultCollapsed: boolean): {
  collapsed: boolean;
  setCollapsed: (v: boolean) => void;
} {
  const [collapsed, setCollapsedState] = React.useState<boolean>(() => {
    try {
      const raw = typeof window !== "undefined" ? localStorage.getItem(key) : null;
      if (raw === "true") return true;
      if (raw === "false") return false;
      return defaultCollapsed;
    } catch {
      return defaultCollapsed;
    }
  });

  const setCollapsed = React.useCallback((v: boolean) => {
    setCollapsedState(v);
    try { localStorage.setItem(key, String(v)); } catch {}
  }, [key]);

  return { collapsed, setCollapsed };
}
